(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["jql-tools"] = factory();
	else
		root["jql-tools"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.helpers = exports.types = undefined;

	var _types = __webpack_require__(1);

	var types = _interopRequireWildcard(_types);

	var _helpers = __webpack_require__(3);

	var helpers = _interopRequireWildcard(_helpers);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	exports.types = types;
	exports.helpers = helpers;

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Event = undefined;

	var _Event = __webpack_require__(2);

	var _Event2 = _interopRequireDefault(_Event);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.Event = _Event2.default;

/***/ },
/* 2 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/* Event
	 *
	 * A class that represents a JQL event in Mixpanel.
	 *
	 */

	var Event = function Event(name) {
	  var properties = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	  _classCallCheck(this, Event);

	  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	    properties = name;
	  }
	  this.event = name;
	  this.selector = properties.selector;
	};

	exports.default = Event;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DateHelper = exports.EventHelper = undefined;

	var _EventHelper = __webpack_require__(4);

	var EventHelper = _interopRequireWildcard(_EventHelper);

	var _DateHelper = __webpack_require__(5);

	var DateHelper = _interopRequireWildcard(_DateHelper);

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

	exports.EventHelper = EventHelper;
	exports.DateHelper = DateHelper;

/***/ },
/* 4 */
/***/ function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.equals = equals;
	exports.containsEvent = containsEvent;
	function equals(e1, e2) {
	  var e1name = e1.event || e1.name;
	  var e2name = e2.event || e2.name;
	  return e1name === e2name;
	}

	function containsEvent(eventCollection, event) {
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;

	  try {
	    for (var _iterator = eventCollection[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var ev = _step.value;

	      if (equals(ev, event)) {
	        return true;
	      }
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }

	  return false;
	}

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatDate = formatDate;
	exports.getStartOfWeek = getStartOfWeek;
	exports.getTimezoneOffset = getTimezoneOffset;
	function formatDate(date) {
	  if (!date.toISOString) {
	    date = new Date(date);
	  }
	  return date.toISOString().split('T')[0];
	}

	function getStartOfWeek(date) {
	  var d = new Date(+date);
	  d.setHours(0, 0, 0);
	  d.setDate(d.getDate() + 1 - (d.getDay() || 7));
	  return d;
	}

	function getTimezoneOffset() {
	  return 60 * new Date().getTimezoneOffset() * 1000;
	}

	var ONE_DAY = exports.ONE_DAY = 60 * 60 * 24 * 1000;
	var THIRTY_DAYS = exports.THIRTY_DAYS = 30 * ONE_DAY;
	var ONE_WEEK = exports.ONE_WEEK = ONE_DAY * 7;
	var SIXTY_DAYS = exports.SIXTY_DAYS = 60 * 60 * 24 * 60 * 1000;

/***/ }
/******/ ])
});
;


/*****************
 ** WEBPACK FOOTER
 ** ./~/jql-tools/lib/index.js
 ** module id = 2
 ** module chunks = 0
 **/